import React, { Component } from 'react';

import YoutubeEmbed from '@js/components/Common/YoutubeEmbed';
import SafeHTML from '@js/components/Common/SafeHTML';
import Comment from './Comment';

class TabContent extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleGetTab = (tab) => {
    const { setTabType } = this.props;
    setTabType(tab);
  };

  render() {
    const {
      prdPageBrandStyle,
      product,
      // productDesc,
      tabType,
    } = this.props;
    // const DescImg = productDesc
    //   ? `<div class="mt-4"><img src=${productDesc} class="img-fluid" /></div>`
    //   : '';
    const {
      rightTextInfo: { sku, name },
      reviews,
    } = product;

    return (
      <>
        <section>
          <div className="container pb-5">
            <ul className="nav nav-tabs mb-4" id="myTab" role="tablist">
              <li className="nav-item product__nav-item col-4" role="presentation">
                <button
                  className={`nav-link col-12 product__btn-nav-item ${
                    tabType === 'spec' ? 'active' : ''
                  }`}
                  id="spec-tab"
                  type="button"
                  role="tab"
                  aria-controls="spec"
                  aria-selected={tabType === 'spec' ? 'true' : 'false'}
                  onClick={() => this.handleGetTab('spec')}
                >
                  商品描述
                </button>
              </li>
              <li className="nav-item product__nav-item col-4" role="presentation">
                <button
                  className={`nav-link col-12 product__btn-nav-item ${
                    tabType === 'logistic' ? 'active' : ''
                  }`}
                  id="logistic-tab"
                  type="button"
                  role="tab"
                  aria-controls="logistic"
                  aria-selected={tabType === 'logistic' ? 'true' : 'false'}
                  onClick={() => this.handleGetTab('logistic')}
                >
                  送貨及付款方式
                </button>
              </li>
              <li className="nav-item product__nav-item col-4" role="presentation">
                <button
                  className={`nav-link col-12 product__btn-nav-item ${
                    tabType === 'comment' ? 'active' : ''
                  }`}
                  id="comment-tab"
                  type="button"
                  role="tab"
                  aria-controls="comment"
                  aria-selected={tabType === 'comment' ? 'true' : 'false'}
                  onClick={() => this.handleGetTab('comment')}
                >
                  顧客評價
                </button>
              </li>
            </ul>
            <div className="tab-content" id="myTabContent">
              <div
                className={`tab-pane fade px-1 px-md-5 ${tabType === 'spec' ? 'show active' : ''}`}
                id="spec"
                role="tabpanel"
                aria-labelledby="spec-tab"
                // dangerouslySetInnerHTML={{
                //   // __html: product.description + DescImg,
                //   __html: product.description,
                // }}
              >
                {/* MMM -  YouTobe 視頻板塊 */}
                {product.imageInfo &&
                  product.imageInfo.youtubeKey && prdPageBrandStyle === 'mmm' && (
                    <YoutubeEmbed embedId={product.imageInfo.youtubeKey} customClass="mb-3" />
                )}
                <SafeHTML html={product.description} />
              </div>
              <div
                className={`tab-pane fade px-1 px-md-5 ${
                  tabType === 'logistic' ? 'show active' : ''
                }`}
                id="logistic"
                role="tabpanel"
                aria-labelledby="logistic-tab"
              >
                <div className="row">
                  <div className="col-12 col-md-4">
                    送貨方式：
                    <br />
                    <ul className="product__list-logistics">
                      {product.deliveryModes?.map((logistic, i) => (
                        <li className="product__list-item-logistics" key={i}>
                          {logistic.title}
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div className="col-12 col-md-4">
                    付款方式：
                    <br />
                    <ul className="product__list-payments">
                      {product.payType?.map((payment, i) => (
                        <li className="product__list-item-payments" key={i}>
                          {payment.type}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
              <div
                className={`tab-pane fade px-1 px-md-5 ${
                  tabType === 'comment' ? 'show active' : ''
                }`}
                id="comment"
                role="tabpanel"
                aria-labelledby="comment-tab"
              >
                <Comment {...this.props} productID={sku} productName={name} reviews={reviews} />
              </div>
            </div>
          </div>
        </section>
      </>
    );
  }
}
export default TabContent;
